import React from 'react';
import styled from 'styled-components';

const Spinner = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  &:after {
    content: " ";
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 auto;
    border-radius: 50%;
    border: 3px solid ${props => props.$color || '#5C6C4B'};
    border-color: ${props => props.$color || '#5C6C4B'} transparent #e2e8f0 transparent;
    animation: dual-ring-spin 1.1s linear infinite;
  }
  @keyframes dual-ring-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Accept color prop
const DualRingSpinner = ({ color }) => <Spinner $color={color} />;

export default DualRingSpinner; 